module.exports = __webpack_public_path__ + "static/media/screenshot3.bdd061d6.png";